// extracted by mini-css-extract-plugin
export default {"banner":"TldlSearchModalBanner_banner__CYkH5"};